import { changeToZeroMoment } from './timeHelpers';

export const groupData = (data: any) => {
    const { substitutedProviderDropDown, providerDropDown, seanceDateFrom, seanceDateTo, ...restData } = data;
    const arrSeance = Object.keys(restData.seances).map((key) => {
        return {
            ...restData.seances[key],
            seance: key,
        };
    });
    if (substitutedProviderDropDown) {
        restData.substitutedProvider = data.substitutedProviderDropDown?.value;
    }
    if (providerDropDown) {
        restData.provider = data.substitutedProviderDropDown?.value;
    }

    if (seanceDateFrom) {
        restData.seanceDateFrom = changeToZeroMoment(seanceDateFrom, 'YYYY-M-D');
    }
    if (seanceDateTo) {
        restData.seanceDateTo = changeToZeroMoment(seanceDateTo, 'YYYY-M-D');
    }

    delete restData.seances;

    return {
        ...restData,
        seances: arrSeance,
    };
};
